import { render, staticRenderFns } from "./parallel_diff_view.vue?vue&type=template&id=5967c882&"
import script from "./parallel_diff_view.vue?vue&type=script&lang=js&"
export * from "./parallel_diff_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "parallel_diff_view.vue"
export default component.exports